import React from 'react';
import { VtexButton } from '../../../styleguide/VtexButton';
import { useLogin } from '../../Login/hooks/useLogin';

type LoginOptionsListItemProps = { handleClick?: () => void };

const EmailAndPassOption = ({ handleClick }: LoginOptionsListItemProps) => {
	const { emailAndPasswordTitle } = useLogin();

	return (
		<div className="vtex-login-2-x-button button vtex-login-2-x-accessCodeOptionBtn accessCodeOptionBtn">
			<VtexButton variation="secondary" block handleClick={handleClick}>
				<span>{emailAndPasswordTitle}</span>
			</VtexButton>
		</div>
	);
};

export default EmailAndPassOption;
